import React from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import clsx from "clsx"

export const ModalConfirm: React.FC<{
  message: IModalMessage | undefined
  setMessage: (msg: IModalMessage | undefined) => void
  className?: string
}> = ({ message, setMessage, className }) => {
  const reject = () => {
    if (message?._callback) {
      message._callback(undefined)
    }
    setMessage(undefined)
  }

  const confirm = () => {
    if (message?._callback) {
      message._callback(message.callbackValue)
    }
    setMessage(undefined)
  }

  if (message) {
    return (
      <section className={clsx("popup-forms index-top", className)} id="error-popup">
        <div className="container-popup-forms">
          <button className="close-btn-card" id="password-close" onClick={reject} />
          <div className="popup-card">
            <h4 className="heading-chapter">{message.title}</h4>
            <p>{message.text}</p>
            <div className="flex-row-24">
              <button className="btn" onClick={confirm}>
                ОК
              </button>
              <button className="btn grey-btn" onClick={reject}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return <></>
  }
}
